module.exports = __webpack_public_path__ + "static/sponsorship_img-06-a-32cce2e363f18513633936d427a24b56.jpg";